import React, { useState, useContext } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  Home, Users, Wrench, LayoutGrid, UserCog, CalendarCheck,
  FileText, HelpCircle, BarChart2, DollarSign,
  HeadphonesIcon, Settings, LogOut, Menu, AlertTriangle,
  X, ChevronDown, ChevronRight, Crown, CheckCircle, ShieldCheck,
  ImageIcon, Bell, MessageCircle,
} from 'lucide-react';
import axios from 'axios';
import Swal from "sweetalert2";

import { useEffect } from "react";
import AppContext from '../../../../context/AppContext';
import echo from '../../../../config/echo';
import '../../../../assets/css/screens/admin/dashboard/adminsidebar/AdminSidebar.css';

// ── Grouped Menu ──
const MENU_GROUPS = [
  {
    id: 'overview',
    label: null, // no section heading for top items
    items: [
      { id: 'home', icon: Home, label: 'Dashboard', path: '/admin-home' },
      // { id: 'report', icon: BarChart2, label: 'Reports', path: '/view-report'  },
      { id: 'earn', icon: DollarSign, label: 'Earnings', path: '/admin-earnings' },
      { id: 'notification', icon: Bell, label: 'Notification', path: '/admin-notification' },
    ],
  },
  {
    id: 'system',
    label: 'System',
    icon: Settings,
    children: [
      { id: 'cats', icon: LayoutGrid, label: 'Categories', path: '/admin-categories' },
      { id: 'bid-jobs', icon: LayoutGrid, label: 'Post Jobs', path: '/system-jobs' },

      // 👇 NEW KYC PAGE
      { id: 'kyc', icon: ShieldCheck, label: 'KYC Verification', path: '/admin-kyc' },
      { id: 'platform-media', icon: ImageIcon, label: 'Platform Media', path: '/platform-media' },

      { id: 'tickets', icon: HeadphonesIcon, label: 'Support Tickets', path: '/support-tickets' },
      { id: 'sub', icon: Crown, label: 'Subscriptions', path: '/admin-subscriptions' },
      { id: 'feedback', icon: MessageCircle, label: 'System Feedbacks', path: '/system-feedback' },
    ],
  },
  {
    id: 'content',
    label: 'Content',
    icon: FileText,
    children: [
      { id: 'blogs', icon: FileText, label: 'Blogs', path: '/admin-blogs' },
      { id: 'faq', icon: HelpCircle, label: 'FAQs', path: '/admin-faqs' },
    ],
  },
  {
    id: 'config',
    label: null,
    items: [
      { id: 'settings', icon: Settings, label: 'Settings', path: '/admin-settings' },
    ],
  },
];

// ── Single NavLink item ──
const SidebarLink = ({ item, onClick, unreadCount }) => {
  const Icon = item.icon;

  return (
    <NavLink
      to={item.path}
      className={({ isActive }) =>
        'asb__link' + (isActive ? ' asb__link--active' : '')
      }
      onClick={onClick}
    >
      <div className="asb__link-icon-wrapper">

        <Icon size={19} className="asb__link-icon" />

        {item.id === 'notification' && unreadCount > 0 && (
          <span className="asb__notification-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}

      </div>

      <span className="asb__link-label">
        {item.label}
      </span>

      <span className="asb__link-arrow">
        ›
      </span>
    </NavLink>
  );
};

// ── Collapsible group ──
const SidebarGroup = ({ group, onLinkClick }) => {
  const location = useLocation();
  const isAnyChildActive = group.children?.some(c => location.pathname === c.path);
  const [open, setOpen] = useState(isAnyChildActive);
  const Icon = group.icon;

  return (
    <div className="asb__group">
      <button
        className={`asb__group-btn${open ? ' asb__group-btn--open' : ''}${isAnyChildActive ? ' asb__group-btn--has-active' : ''}`}
        onClick={() => setOpen(o => !o)}
      >
        <Icon size={19} className="asb__link-icon" />
        <span className="asb__link-label">{group.label}</span>
        {open
          ? <ChevronDown size={15} className="asb__group-chevron" />
          : <ChevronRight size={15} className="asb__group-chevron" />
        }
      </button>

      {open && (
        <div className="asb__group-children">
          {group.children.map(item => (
            <SidebarLink key={item.id} item={item} onClick={onLinkClick} />
          ))}
        </div>
      )}
    </div>
  );
};

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
  // token k liya ye 2 lines
  const location = useLocation();
  const { baseUrl, authToken, setAuthToken } = useContext(AppContext);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const adminId = localStorage.getItem("subadminId");

  const navigate = useNavigate();

  const handleLogout = () => {

    setLogoutLoading(true);

    axios.post(
      `${baseUrl}/subadmin/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },
      }
    )
      .then(() => {

        Swal.fire({
          icon: "success",
          title: "Logged Out",
          text: "Logout successful.",
          timer: 1500,
          showConfirmButton: false,
        });

      })
      .catch(() => {



      })
      .finally(() => {

        localStorage.removeItem("authToken");
        localStorage.removeItem("email");
        localStorage.removeItem("password");

        setAuthToken(null);
        setLogoutLoading(false);

        setTimeout(() => {
          navigate("/");
        }, 1500);

      });

  };

  const handleLinkClick = () => {
    if (isOpen) toggleSidebar();
  };
  // token k liya 
  useEffect(() => {
    const token = localStorage.getItem("authToken");

    console.log("--------------------------------");
    console.log("ADMIN PAGE CHANGED:");
    console.log("PATH:", location.pathname);
    console.log("TOKEN:", token);
    console.log("--------------------------------");

  }, [location]);
  const fetchUnreadCount = async () => {

  if (!authToken) {
    return;
  }

  try {

    const response = await axios.get(
      `${baseUrl}/admin/unread/count`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },
      }
    );

    setUnreadCount(response.data.count);

  } catch (error) {

    console.log(
      "Unread notification count error:",
      error.response?.data
    );

  }

};
useEffect(() => {

  if (authToken) {
    fetchUnreadCount();
  }

}, [baseUrl, authToken]);
  useEffect(() => {
    console.log(localStorage.getItem("authToken"));
  }, [location]);
  useEffect(() => {

  if (!adminId) {
    console.log("Subadmin ID not found");
    return;
  }

  console.log(
    "Joining Admin Notification Channel:",
    `admin-${adminId}`
  );

  const channel = echo.channel(`admin-${adminId}`);

  channel.subscribed(() => {

    console.log(
      "Admin Notification Sidebar Channel Joined"
    );

  });

 channel.listen(".NotificationUpdates", (event) => {

  console.log(
    "Sidebar Notification Socket Event:",
    event
  );

  if (!event.notification) {
    return;
  }

  setTimeout(() => {
    fetchUnreadCount();
  }, 300);

});

  return () => {

    console.log(
      "Leaving Admin Notification Channel:",
      `admin-${adminId}`
    );

    echo.leave(`admin-${adminId}`);

  };

}, [adminId, authToken]);
  return (
    <>
      {/* ══ MOBILE TOPBAR ══ */}
      <div className="asb-mob-topbar">
        <button className="asb-mob-topbar__hamburger" onClick={toggleSidebar}>
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
        <div className="asb-mob-topbar__brand">
          <span className="asb-mob-topbar__dash">━━</span>
          <span className="asb-mob-topbar__name">Admin</span>
        </div>
      </div>

      {/* ══ OVERLAY ══ */}
      {isOpen && <div className="asb-overlay" onClick={toggleSidebar} />}

      {/* ══ SIDEBAR ══ */}
      <aside className={'asb' + (isOpen ? ' asb--open' : '')}>

        {/* Header */}
        <div className="asb__header">

          <div>
            <h3 className="asb__brand">Picks4Tips</h3>
            {/* <h5 className="asb__sub">Admin Panel</h5> */}
          </div>
        </div>

        {/* Nav */}
        <nav className="asb__nav">
          {MENU_GROUPS.map(group => {
            // flat items (no dropdown)
            if (group.items) {
              return (
                <div key={group.id} className="asb__flat-group">
                  {group.items.map(item => (
                    <SidebarLink
                      key={item.id}
                      item={item}
                      onClick={handleLinkClick}
                      unreadCount={unreadCount}
                    />
                  ))}
                </div>
              );
            }
            // collapsible group
            return (
              <div key={group.id} className="asb__section">
                <SidebarGroup group={group} onLinkClick={handleLinkClick} />
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="asb__footer">
          <button
            className="asb__logout"
            onClick={handleLogout}
            disabled={logoutLoading}
          >
            {logoutLoading ? (
              <>
                <span className="loader"></span>
                <span>Please wait...</span>
              </>
            ) : (
              <>
                <LogOut size={18} />
                <span>Logout</span>
              </>
            )}
          </button>
        </div>

      </aside>
    </>
  );
};

export default AdminSidebar;